import { getPokemonPower } from '~/data/pokemonPower'
import type { Rarity } from '~/data/gacha'

const neutralDpsMemo = new Map<string, number>()

export function calculateNeutralDPS(
  team: Array<{ slug: string; level: number; stars: number; isShiny: boolean; rarity?: Rarity }>
): number {
  if (team.length === 0) return 0
  const signature = team
    .map((p) => `${p.slug}:${p.level}:${p.stars}:${p.isShiny ? 1 : 0}:${p.rarity ?? 'common'}`)
    .join('|')
  const memoized = neutralDpsMemo.get(signature)
  if (memoized !== undefined) return memoized

  let total = 0
  for (const poke of team) {
    total += getPokemonPower(poke)
  }
  neutralDpsMemo.set(signature, total)
  if (neutralDpsMemo.size > 200) {
    neutralDpsMemo.clear()
  }
  return total
}
